const digest = 'd191862a88cb5e8b73c60c60d09eda35f8cb93fe07bcaf4f62cbbc7ee1dd0e9d';
const css = `._popup_cd6dk_1{left:0;position:absolute;top:-.625rem;z-index:80}@media (max-width:799px){._popup_cd6dk_1{bottom:0;left:0!important;overflow:auto;position:fixed;right:0;top:0;width:auto;z-index:10400}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'popup': '_popup_cd6dk_1' };
export const popup = '_popup_cd6dk_1';
export { css, digest };